<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list">
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="title-wrapper">
          <div>
            <h1 class="title-default">Formas de Envio</h1>
            <p class="welcome-message">
              <button mat-icon-button routerLink="/configuracoes/vendas">
                <mat-icon>arrow_back</mat-icon>
              </button>
              Visualize e gerencie as formas de envio.
            </p>
          </div>
        </div>
      </div>
      <div class="col-md-6 header-actions">
        <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="opcoesMenu">
          @if (selection.hasValue()) { <span>Ações ({{ selection.selected.length }})</span> } @else {
          <span>Ações</span> }
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #opcoesMenu="matMenu">
          <button mat-menu-item (click)="abrirModalExcluir()" [disabled]="!selection.hasValue()">
            <mat-icon class="material-symbols-outlined">delete</mat-icon>
            <span>Excluir selecionados</span>
          </button>
        </mat-menu>
        <button type="button" mat-flat-button class="btn-primary"
          routerLink="/configuracoes/vendas/formas-envio/cadastrar">
          <mat-icon class="material-symbols-outlined">add</mat-icon> Incluir forma de envio
        </button>
      </div>
    </div>

    <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
      <div class="row search-area">
        <div class="col-12 col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>Pesquisar</mat-label>
            <input matInput type="text" formControlName="descricao" placeholder="Busque pela descrição...">
            <button mat-icon-button matSuffix type="submit" aria-label="Pesquisar">
              <mat-icon>search</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div class="col-12 col-md-8 mb-3 mb-md-0 filter-actions">
          <button mat-stroked-button type="button" class="btn-filter" [matMenuTriggerFor]="filtroMenu"
            [matBadge]="qtdFiltrosAtivos" [matBadgeHidden]="qtdFiltrosAtivos === 0">
            <mat-icon>filter_list</mat-icon>
            Filtrar
          </button>
          <mat-menu #filtroMenu="matMenu" class="filter-custom-menu">
            <div class="filter-menu-content" [formGroup]="model">
              <div (click)="$event.stopPropagation()">
                <h6>Filtros Avançados</h6>
                <div class="filter-menu__form">
                  <mat-form-field appearance="outline">
                    <mat-label>Tipo de logística</mat-label>
                    <mat-select formControlName="idTipoLogistica">
                      <mat-option [value]="null">Todos</mat-option>
                      @for (tipo of _tiposLogistica; track tipo.idTipoLogistica) {
                      <mat-option [value]="tipo.idTipoLogistica">{{ tipo.descricao }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field appearance="outline">
                    <mat-label>Status</mat-label>
                    <mat-select formControlName="isAtivo">
                      <mat-option [value]="null">Todos</mat-option>
                      <mat-option [value]="true">Ativo</mat-option>
                      <mat-option [value]="false">Inativo</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="filter-menu__actions">
                <button mat-button class="btn-secondary" matMenuClose>Cancelar</button>
                <button mat-flat-button class="btn-primary" (click)="clickPesquisar()" matMenuClose>Aplicar</button>
              </div>
            </div>
          </mat-menu>

          <button mat-stroked-button type="button" class="btn-filter" (click)="limparFiltros()">
            <mat-icon>cleaning_services</mat-icon>
            Limpar Filtros
          </button>
        </div>
      </div>
    </form>

    @if (_isLoading && _dataSource.data.length === 0) {
    <app-loading-box-default-list></app-loading-box-default-list>
    } @else if (_dataSource.data.length > 0) {

    <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="w-checkbox">
          <mat-checkbox (change)="$event ? toggleAllRows() : null"
            [checked]="selection.hasValue() && isAllSelected()"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let row" class="w-checkbox">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="descricao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Descrição</th>
        <td mat-cell *matCellDef="let element">{{ element.descricao }}</td>
      </ng-container>

      <ng-container matColumnDef="tipo">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tipo</th>
        <td mat-cell *matCellDef="let element">{{ element.descricaoTipoLogistica }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          <span class="status-badge" [ngClass]="element.isAtivo ? 'badge-verde' : 'badge-cinza'">
            {{ element.isAtivo ? 'Ativo' : 'Inativo' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
        <td mat-cell *matCellDef="let element" class="text-center w-actions">
          <button mat-icon-button [matMenuTriggerFor]="menu">
            <span class="material-symbols-outlined">more_horiz</span>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editar(element.idFormaEnvio)">
              <span class="material-symbols-outlined">edit</span><span>Editar</span>
            </button>
            <button mat-menu-item (click)="toggleAtivo(element)">
              <span class="material-symbols-outlined">{{ element.isAtivo ? 'toggle_off' : 'toggle_on' }}</span>
              <span>{{ element.isAtivo ? 'Inativar' : 'Ativar' }}</span>
            </button>
            <button mat-menu-item (click)="abrirModalExcluir(element)">
              <span class="material-symbols-outlined">delete</span><span>Excluir</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <div class="mobile-view">
      @for (item of _dataSource.data; track item.idFormaEnvio) {
      <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
        <div class="card-header-mobile d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center gap-2">
            <mat-checkbox (change)="$event ? selection.toggle(item) : null"
              [checked]="selection.isSelected(item)" color="primary"></mat-checkbox>
            <div>
              <span class="text-bold">{{ item.descricao }}</span>
              <br>
              <small>{{ item.descricaoTipoLogistica }}</small>
            </div>
          </div>
          <div class="d-flex align-items-center gap-2">
            <span class="status-badge" [ngClass]="item.isAtivo ? 'badge-verde' : 'badge-cinza'">
              {{ item.isAtivo ? 'Ativo' : 'Inativo' }}
            </span>
            <button mat-icon-button [matMenuTriggerFor]="menuMobile">
              <span class="material-symbols-outlined">more_horiz</span>
            </button>
            <mat-menu #menuMobile="matMenu">
              <button mat-menu-item (click)="editar(item.idFormaEnvio)">Editar</button>
              <button mat-menu-item (click)="toggleAtivo(item)">{{ item.isAtivo ? 'Inativar' : 'Ativar' }}</button>
              <button mat-menu-item (click)="abrirModalExcluir(item)">Excluir</button>
            </mat-menu>
          </div>
        </div>
      </div>
      }
    </div>

    <div class="col-12 text-center mt-4 mb-5">
      <button mat-button class="btn-ver-mais"
        [disabled]="_isLoading || _dataSource.data.length >= _totalRegistros" (click)="proximaPagina()">
        @if (_isLoading) { <mat-spinner [diameter]="20"></mat-spinner> } @else {
        <span class="material-symbols-outlined">expand_more</span> Ver Mais }
      </button>
    </div>

    } @else {
    <app-empty-list [title]="'Nenhuma forma de envio encontrada'"
      [subTitle]="'Adicione uma nova forma de envio para começar'"></app-empty-list>
    }
  </div>
</div>
